import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Icon } from '@millionshow/client-libs';

@Component({
  selector: 'app-registration-page',
  imports: [CommonModule, Icon],
  templateUrl: './registration.page.html',
})
export default class RegistrationPage {}
